export default __webpack_public_path__ + "static/media/asiaSquare1.jpg?.fc59172b";